module.exports = __webpack_public_path__ + "img/2手机.3ca5e8ba.png";